import { useMutateClearSecondaryCategoryReportAccess } from '../../models/useMutateClearSecondaryCategoryReportAccess'

/**
 * Bare command: deletes every `view_report` grant on one SecondaryCategory
 * (BHV-019). The promise REJECTS on error so the Feature-Set-owned
 * confirmation handler toasts from the caught error (ADR-10). The danger
 * dialog, n=0 guard (BHV-020), and all copy are Feature Set concerns.
 */
export const useClearSecondaryCategoryReportAccessPresenter = () => {
  const { clearSecondaryCategoryReportAccess, isClearing } =
    useMutateClearSecondaryCategoryReportAccess()

  const clearAll = async (secondaryCategoryId: number): Promise<void> => {
    await clearSecondaryCategoryReportAccess({ secondaryCategoryId })
  }

  return {
    commands: {
      clearAll,
    },
    states: {
      isClearing,
    },
  }
}
